import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Typography } from '@mui/material';

import { CloseButton, Dialog, DialogActions, DialogContent, DialogTitle, SubmitButton } from 'components';
import { ROUTES } from 'consts';
import { BuildingForm } from 'forms';
import { useAppSelector } from 'store/store.hook';
import { selectCurrentUserInfo } from 'store/slices/auth.slice';

interface BuildingCreateDialogProps {
  visible?: boolean;
  setVisible?: (value: boolean) => void;
  title?: string;
  submitButtonLabel?: string;
}

export const BuildingCreateDialog: React.FC<BuildingCreateDialogProps> = ({
  visible = false,
  setVisible = () => {},
  title = 'Add a new building',
  submitButtonLabel = 'Add Building',
}: BuildingCreateDialogProps) => {
  const [loading, setLoading] = useState<boolean>(false);
  const navigate = useNavigate();
  const { orgSlug } = useAppSelector(selectCurrentUserInfo);

  const formRef = React.useRef<any>();

  const onClose = (event: any, reason: string) => {
    if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
      setVisible(false);
      document.body.removeAttribute('style');
    }
  };

  const onSubmit = () => {
    formRef.current.onSubmit();
  };

  return (
    <Dialog open={visible} onClose={onClose}>
      <DialogTitle>
        <Typography variant="h5" component="span">
          {title}
        </Typography>
      </DialogTitle>

      <DialogContent>
        <BuildingForm
          ref={formRef}
          onSubmitting={(loading) => setLoading(!!loading)}
          next={({ id }) => {
            navigate(`/${orgSlug}/${ROUTES.ZONES}/${ROUTES.ZONES_ACTIVE}?building=${id}`);
            setVisible(false);
          }}
        />
      </DialogContent>

      <DialogActions>
        <SubmitButton loading={loading} label={submitButtonLabel} onClick={onSubmit} />
      </DialogActions>

      <CloseButton onClick={() => onClose(null, 'anyway')} />
    </Dialog>
  );
};
